import { render, staticRenderFns } from "./ListFactura.vue?vue&type=template&id=6d450bc6&"
import script from "./ListFactura.vue?vue&type=script&lang=js&"
export * from "./ListFactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports